if (!customElements.get('split-image-banner-media')) {
  class SplitImageBannerMedia extends HTMLElement {
  connectedCallback() {
    const container = this.closest('.split-image-banner__container');
    if (!container) return;

    const playTpl = container.querySelector('[data-sib-icon-play]');

    container.querySelectorAll('.split-image-banner__media').forEach((wrap) => {
      const videos = Array.from(wrap.querySelectorAll('video'));
      if (!videos.length || wrap.querySelector('.split-image-banner__media-play-btn')) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'split-image-banner__media-play-btn';
      btn.setAttribute('aria-label', 'Play video');
      btn.setAttribute('tabindex', '-1');
      if (playTpl) btn.appendChild(playTpl.content.cloneNode(true));
      wrap.appendChild(btn);

      const currentVideo = () => videos.find((video) => video.offsetParent !== null) || videos[0];

      const sync = () => {
        btn.classList.toggle('is-paused', currentVideo().paused);
      };

      videos.forEach((video) => {
        video.muted = true;
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
      });
      sync();
    });
  }
}

  customElements.define('split-image-banner-media', SplitImageBannerMedia);
}
